/**
 * @author       luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { selectFilters } from '@zcode-ui/filters'
import type { State } from '@zcode/state-type'

export const getLeaseLengthType = (state: State) => {
  const filters = selectFilters(state) ?? {}
  const { longTerm, shortTerm } = filters
  const hasNoLeaseLength = !longTerm && !shortTerm

  if (hasNoLeaseLength || longTerm) {
    return 'Long Term'
  }

  return 'Short Term'
}
